export enum AuthenticationTypes {
  OAUTH2 = 'OAuth2',
  MULTIPLE = 'Multiple',
  LDAP = 'Ldap',
  WINDOWS = 'Windows'
}

export enum AuthenticationProperties {
  OAUTH_OPTIONS = 'oauthOptions',
  ACTIVE_FLOW = 'activeFlow',
  OPTIONS = 'options',
  TYPE = 'type',
  SUBTYPE = 'subtype',
  CONFIG = 'config',
  SUBTYPES = 'subtypes',
  FLOWS = 'flows'
}
